/* eslint-disable @typescript-eslint/no-empty-function */
export const PHOTON_URL = 'https://photon.komoot.io';
import axios, { AxiosResponse } from "axios";
import { PhotonFeatureCollection } from "./models/photon.model";

export class PhotonService {

    private static _instance: PhotonService | null = null;

    static getInstance(): PhotonService {
        if (!PhotonService._instance) {
            PhotonService._instance = new PhotonService();
        }
        return PhotonService._instance;
    }

    private constructor() {
    }

    search(city: string): Promise<PhotonFeatureCollection> {
        const params = { q: city};

        return axios.get<PhotonFeatureCollection>(`${PHOTON_URL}/api`, { params})
            .then((axiosResponse: AxiosResponse<PhotonFeatureCollection>) => {
                return axiosResponse.data;
            })
    }

    searchByLocation(lat: number, lon: number): Promise<PhotonFeatureCollection> {
        const params = { lat, lon };
        return axios.get<PhotonFeatureCollection>(`${PHOTON_URL}/reverse`, { params})
            .then((axiosResponse: AxiosResponse<PhotonFeatureCollection>) => {
                return axiosResponse.data;
            })
    }
}